import { render, staticRenderFns } from "./ProjectsButton.vue?vue&type=template&id=19d05939&"
import script from "./ProjectsButton.vue?vue&type=script&lang=js&"
export * from "./ProjectsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports